import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { getConfig } from '@/config';
import { useAuthStore } from '@/store';
const useClaims = () => {
    const { getIdTokenClaims, isAuthenticated, user } = useAuth0();
    const { user_metadata: prev, setAuthProfile } = useAuthStore();
    const { REACT_APP_AUTH0_NAMESPACE: namespace } = getConfig();
    const loadUserMetadata = useCallback(async () => {
        if (prev?.owner_ids) {
            return prev;
        }
        if (!isAuthenticated) {
            throw new Error('Unauthenticated');
        }
        const claims = await getIdTokenClaims();
        if (!claims) {
            throw new Error('No token claims found');
        }
        const roles = claims[`${namespace}roles`] || [];
        const user_metadata = claims[`${namespace}metadata`] || {};
        setAuthProfile({ ...user, roles, user_metadata });
        return user_metadata;
    }, [
        prev,
        isAuthenticated,
        getIdTokenClaims,
        namespace,
        setAuthProfile,
        user,
    ]);
    return { loadUserMetadata };
};
export default useClaims;
